import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { renderWorkOrderInfoData } from 'af-root/scenes/Company/ScheduleBoard/Shared/OrderInfoModal';

import type WorkOrderModalViewModel from 'ab-viewModels/scheduleBoardWorkOrderModal.viewModel';

import { isAllowed } from '@acceligentllc/shared/utils/auth';

import type { RootState } from 'af-reducers';

import PagePermissions from 'ab-enums/pagePermissions.enum';

interface OwnProps {
	workOrderDataToShow: WorkOrderModalViewModel;
	currentWorkOrderData: WorkOrderModalViewModel;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

class CurrentStatusSection extends React.PureComponent<Props> {
	render() {
		const { workOrderDataToShow, currentWorkOrderData, canViewForeman } = this.props;

		return (
			<div className="work-order-info-modal__general-info">
				<div className="work-order-info-modal__general-info-left">
					<div className="work-order-info-modal__important-info">
						{renderWorkOrderInfoData(workOrderDataToShow?.customerName, currentWorkOrderData?.customerName)}
					</div>
					<div className="work-order-info-modal__important-info">
						{renderWorkOrderInfoData(workOrderDataToShow?.title, currentWorkOrderData?.title)}
					</div>
					<div className="work-order-info-modal__important-info">
						{renderWorkOrderInfoData(workOrderDataToShow?.workLocationAddress, currentWorkOrderData?.workLocationAddress)}
					</div>
				</div>
				<div className="work-order-info-modal__general-info-right">
					<div className="work-order-info-modal__important-info">
						{renderWorkOrderInfoData(workOrderDataToShow?.officeNickname ?? '-', currentWorkOrderData?.officeNickname ?? '-')}
					</div>
					<div className="work-order-info-modal__important-info">
						{renderWorkOrderInfoData(workOrderDataToShow?.divisionName ?? '-', currentWorkOrderData?.divisionName ?? '-')}
					</div>
					<div className="work-order-info-modal__info">
						Superintendent:
						<strong>
							{renderWorkOrderInfoData(workOrderDataToShow?.supervisor?.fullName ?? null, currentWorkOrderData?.supervisor?.fullName ?? null)}
						</strong>
					</div>
					{(workOrderDataToShow?.projectManager ?? currentWorkOrderData?.projectManager) &&
						<div className="work-order-info-modal__info">
							Project manager:
							<strong>
								{renderWorkOrderInfoData(
									workOrderDataToShow?.projectManager?.fullName ?? null,
									currentWorkOrderData?.projectManager?.fullName ?? null
								)}
							</strong>
						</div>
					}
					{workOrderDataToShow?.crewNumber && canViewForeman &&
						<div className="work-order-info-modal__info">
							Crew Number:
							<strong>
								{renderWorkOrderInfoData(
									workOrderDataToShow?.crewNumber ?? null,
									currentWorkOrderData?.crewNumber ?? null
								)}
							</strong>
						</div>
					}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	const { user: { companyData, userData } } = state;

	if (!userData || !companyData) {
		throw new Error('User not logged in');
	}

	const { isCompanyAdmin, permissions } = companyData;
	const { role } = userData;

	const canViewForeman = isAllowed(
		PagePermissions.COMPANY.FOREMAN.VIEW,
		permissions,
		isCompanyAdmin,
		role
	);

	return {
		canViewForeman,
	};
}

const connector = connect(mapStateToProps);

export default connector(CurrentStatusSection);
